<template>
    <div class="mb-4">
        <!-- Visually-hidden label keeps the control accessible (WCAG 1.3.1 / 4.1.2). -->
        <label for="mobile-sort-select" class="sr-only">{{ sortLabel }}</label>
        <select
            id="mobile-sort-select"
            :value="selectedSort"
            :aria-label="sortLabel"
            @change="onSortChange"
            class="mb-8 block h-full w-full appearance-none rounded-full border-2 bg-[#e5e7eb] bg-[url('/icons/chevron-down.svg')] bg-[center_right_16px] bg-no-repeat p-4 leading-none">
            <option v-for="sort in sorts" :key="sort.key" :value="sort.key">
                {{ sort.translated.label }}
            </option>
        </select>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        sorts: Object,
        currentSort: String,
    });

    const route = useRoute();
    const router = useRouter();

    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;
    const sortLabel = computed<string>(
        () => (snippets?.['headless.productListing.sortBy'] as string | undefined) ?? 'Sorteren op',
    );

    const selectedSort = ref(route.query.sort || props.currentSort || '');

    watch(
        () => route.query.sort,
        newSort => {
            if (newSort && newSort !== selectedSort.value) {
                selectedSort.value = newSort as string;
            }
        },
    );

    watch(
        () => props.sorts,
        sorts => {
            if (Array.isArray(sorts) && sorts.length > 0 && !sorts.some((s: any) => s.key === selectedSort.value)) {
                selectedSort.value = sorts[0].key;
            }
        },
        { immediate: true },
    );

    function onSortChange(event: Event) {
        const newSort = (event.target as HTMLSelectElement).value;
        selectedSort.value = newSort;
        router.push({
            path: route.path,
            query: {
                ...route.query,
                sort: newSort || undefined,
            },
        });
    }
</script>
